module.exports = __webpack_public_path__ + "ecb725dea6d979803d7bbb4b95de055e.png";